import type { Breakpoint } from '../types'

type BreakpointObj = {
  [key: Breakpoint]: number
}

const BREAKPOINTS: BreakpointObj = {
  XS: 0,
  S: 400,
  M: 600,
  L: 750,
  XL: 1500
}

function getCurrentBreakpoint (width: number) {
  return Object.keys(BREAKPOINTS)
    .sort((a, b) => BREAKPOINTS[b] - BREAKPOINTS[a])
    .find(bp => width > BREAKPOINTS[bp])
}

function breakpointToClassName (currentBreakpoint: Breakpoint): string {
  switch (currentBreakpoint) {
    case 'XS':
      return 'extra-small'
    case 'S':
      return 'small'
    case 'L':
      return 'large'
    case 'XL':
      return 'extra-large'
    case 'M':
    default:
      return 'medium'
  }
}

export { breakpointToClassName, getCurrentBreakpoint }



// WEBPACK FOOTER //
// ./src/shared/helpers/breakpointToClassName.js